import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HiddenMarkup = styled.span`
  display: none;
`;

/**
 * Generic component for finding specific errors in components
 *
 * This component can be useful for isolating errors, so that
 * the entire app doesn't crash.
 *
 * @see {@link https://reactjs.org/docs/error-boundaries.html}
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(err) {
    const error = new Error(err);
    window.DD_RUM?.onReady(() => {
      window.DD_RUM.addError(error, {
        location: 'ErrorBoundary'
      });
    });
  }

  render() {
    const {
      props: { children },
      state: { hasError, error }
    } = this;

    if (hasError) {
      // You can render any custom fallback UI
      return <HiddenMarkup data-error-message={error} className="ui-error" />;
    }

    return children;
  }
}

ErrorBoundary.displayName = 'ErrorBoundary';

ErrorBoundary.propTypes = { children: PropTypes.node.isRequired };
